import EventDetails from 'components/EventDetails';
import { useGetAccountById } from 'hooks';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';

function EventDetailsAccountPage() {
  const { eventType, eventId, accountId } = useParams();
  const [searchParams] = useSearchParams();
  const occurrenceId = searchParams.get(`occurrenceId`);
  const account = useGetAccountById(Number(accountId));

  if (!account) {
    console.error(`Não foi encontrada a conta ${accountId} na lista de contas`);
    return <Navigate to="/" />;
  }

  return (
    <EventDetails
      account={account}
      occurrenceId={occurrenceId}
      eventType={Number(eventType)}
      eventId={eventId}
    />
  );
}

export default EventDetailsAccountPage;
